import React from 'react';
import {Modal, Box, Typography, IconButton, useTheme} from '@mui/material';
import FilledButton from "../../../components/buttons/FilledButton";

const OrdersWithSamePurchaseOrderNumberAndDeliveryDateModal = ({ open, onCancel, onConfirm, feature, setConfirmRedirectOpen }) => {
  const theme = useTheme();

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      setConfirmRedirectOpen(false);
    } else {
      onCancel();
    }
  };

  return (
      <Modal open={open} onClose={handleClose}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 450,
          p: 4,
          textAlign: 'center',
          borderRadius: '8px',
          backgroundColor: theme.palette.background.paper,
          "@media (max-width: 768px)": {
            width: "95%",
          },
        }}>
          <IconButton onClick={onCancel} sx={{position: 'absolute', top: 5, right: 5}}>
          </IconButton>

          <Typography
              variant="h4"
              gutterBottom
              sx={{fontSize: '18px', fontWeight: 'bold'}}
          >
            Ya existen los siguientes pedidos para el número de órden de
            compra <strong>{feature.purchaseOrderNumberField()}</strong> y punto de
            entrega <strong>{feature.deliverySiteNameField()}</strong>.
          </Typography>

          {feature.ordersWithSamePurchaseOrderNumberAndDeliverySite().map((order) => (
              <Typography
                  key={order.id}
                  variant="body2"
                  sx={{fontSize: '16px', my: 1}}
              >
                <a
                    href={`/order/${order.orderNumber}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{textDecoration: 'none', color: theme.palette.primary.main}}
                >
                  Número: {order.orderNumber} Fecha: {order.deliveryDate.format("DD-MM-YYYY")}
                </a>
              </Typography>
          ))}

          <Typography
              variant="body1"
              gutterBottom
              sx={{fontSize: '18px'}}
          >
            ¿Desea crear el pedido de todas formas?
          </Typography>

          <Box sx={{mt: 2, display: 'flex', justifyContent: 'space-around'}}>
            <FilledButton onClick={onConfirm}>
              Si, crear pedido
            </FilledButton>
            <FilledButton onClick={onCancel}>
              No, cancelar pedido
            </FilledButton>
          </Box>
        </Box>
      </Modal>
  );
}

export default OrdersWithSamePurchaseOrderNumberAndDeliveryDateModal;
